import React from 'react'
import { ForwardRefExoticComponent, SVGProps } from 'react'

import { Numbers } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { NumberElementQuestion } from 'modules/forms/components/QuestionComponent/NumberElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, Options, elementParam } from 'modules/forms/lib/types'

/**
 * NumberElement class for numeric input elements.
 * Extends the base Element class.
 */
export class NumberElement extends Element {
  static create({ label, options = {} }: { label: string; options: Options }): NumberElement {
    const el = new NumberElement({
      label,
      description: options.description,
      mandatory: options.mandatory || options.locked, //locked element are always mandatory
    })
    if (options.locked) {
      el.lock()
    }

    return el
  }
  /**
   * Get the name of the element
   */
  getName(): string {
    return i18n.t('forms.modals.elements.numeric')
  }

  /**
   * Get the type of the element
   */
  getType(): FormsElementTypeEnum {
    return 'number'
  }

  /**
   * Get the icon for the element
   */
  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return Numbers
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <NumberElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <NumberElementQuestion element={this} onChange={onChange} />
  }

  configureParams(): elementParam[] {
    return [Element.numberParam('min', 'Minimun'), Element.numberParam('max', 'Maximun')]
  }
}
